const subscriptionsStatuses = {
  inProcessing: 'IN_PROGRESS',
  underway: 'WAITING',
  classified: 'FINISHED',
};

export default subscriptionsStatuses;
